import {
   Component, OnInit, OnChanges, OnDestroy,
   Input, Output, ViewChild, ElementRef,
   EventEmitter
} from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';

// config
import { appConfig } from '../../../config/app-config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// Own feature
import { Mangel } from '../../../maengel/model/mangel';
import { MaengelService } from '../../../maengel/service/maengel.service';
import { MaengeldetailMdlgComponent } from '../../../maengel/compv/maengeldetail-mdlg/maengeldetail-mdlg.component';
// Actions
import {
   mangelSelectStock,
   mangelResetStateAll,
   mangelStoreStockObjects,
} from '../../../maengel/store/actions';
import { LoadingphaseService } from '../../../nav/service/loadingphase.service';

const enum SubView {
   HIDE                       = 0,
   MAENGEL_LISTE_EMPTY        = 1 << 1,  // 2
   MAENGEL_LISTE_WITH_ITEMS   = 2 << 1,  // 4
   // exceptions
   INTERNAL_ERROR             = 1 << 11, // 2048
}

@Component({
   selector: 'app-maengelliste-view',
   templateUrl: './maengelliste-view.component.html',
   styleUrls: ['./maengelliste-view.component.scss'],
   providers: [MaengelService]
})
export class MaengellisteViewComponent implements OnInit, OnChanges, OnDestroy {

   // loading data
   public set _loadingPhase(value: boolean) {
    this.loadingphaseService.setLoadingphase(value, 'maengelliste');
   }

   // error
   private _errMsgSubView2 = '';
   private _errMsgSubViewIntErr = 'Es ist ein interner Fehler aufgetreten';

   // pages
   private _subView = SubView.MAENGEL_LISTE_WITH_ITEMS;     // initial SubView

   // table
   public _displayedColumns = ['uid', 'shortage_kind', 'priority', 'date_applicable', 'description', 'component', 'applyEdit'];
   public _dataSource = new MatTableDataSource<Mangel>();

   // input
   @Input() _maengelListe: Mangel[];

   // children
   @ViewChild('paginator') _paginator: MatPaginator;
   @ViewChild( MatSort ) _sort: MatSort;
   @ViewChild('filter') _filter: ElementRef;
   // modal child
   @ViewChild('mdlgMaengelDetail')
   public readonly _mdlgMaengelDetail: MaengeldetailMdlgComponent;

   constructor(
      private _router: Router,
      private _maengelService: MaengelService,
      private loadingphaseService: LoadingphaseService,
   ) { }

   ngOnInit() {
      // -->>ASY
      this._maengelService.loadMaengelListe()
      .then((boolResultASY: IBoolResult) => {
         // result available
         if (boolResultASY.result) {
            this._loadingPhase = true;
            return;
         }

         // no items
         this._subView = SubView.MAENGEL_LISTE_EMPTY;
      })
      .catch((err: ErrorMessage) => {
         // show error sub page
         if (err.module === 'HttpErrorResponse') {
            this.showErrorMessageView2(err.message);
            return;
         }

         // internal error
         this._subView = SubView.INTERNAL_ERROR;
      });
   }

   ngOnChanges() {
      // prerequisites
      if (!this._maengelListe || this._maengelListe.length === 0) {
         return;
      }

      // data available
      this._dataSource.data = this._maengelListe;
      this._dataSource.paginator = this._paginator;
      this.hideSpinnerWithDelay();
   }

   ngOnDestroy() {
      this._maengelService.resetMaengelAllState();
   }

   hideSpinnerWithDelay(): void {
      if (appConfig.dev.mockingMode) {
         setTimeout(function () {
            this._loadingPhase = false;
         }.bind(this), appConfig.dev.durationDelayForMockedData);
         return;
      }
      // immediatelly
      this._loadingPhase = false;
   }

   // ---------------------------------------------------------------------------------------------
   // -- filter
   // ---------------------------------------------------------------------------------------------
   public applyFilter(filterValue: string) {
      // prerequisites
      if (!this._maengelListe || this._maengelListe.length === 0) {
         return;
      }

      // action
      filterValue = filterValue.trim();         // Remove whitespace
      filterValue = filterValue.toLowerCase();  // MatTableDataSource defaults to lowercase matches
      this._dataSource.filter = filterValue;
   }

   public resetFilter() {
      this._filter.nativeElement.value = '';
      this.applyFilter('');
   }

   // ----------------------------------------------------------------------------------------------
   // -- Localization
   // ----------------------------------------------------------------------------------------------

   // ----------------------------------------------------------------------------------------------
   // -- Error
   // ----------------------------------------------------------------------------------------------
   showErrorMessageView2(msg: string): void {
      this._errMsgSubView2 = msg;
      setTimeout(function () {
         this._errMsgSubView2 = '';
      }.bind(this), appConfig.app.errMsgDurationToShow);
   }

   // ----------------------------------------------------------------------------------------------
   // -- Visibility
   // ----------------------------------------------------------------------------------------------
   public showView(): boolean            { return this._subView !== SubView.HIDE; }
   public showSubView1NoItem(): boolean  { return this._subView === SubView.MAENGEL_LISTE_EMPTY; }
   public showSubView2Items(): boolean   { return this._subView === SubView.MAENGEL_LISTE_WITH_ITEMS; }
   // exceptions
   public showSubViewIntErr(): boolean   { return this._subView === SubView.INTERNAL_ERROR; }

   // ----------------------------------------------------------------------------------------------
   // -- SubView 1 - No Items
   // ----------------------------------------------------------------------------------------------
   public onSubmitSubView1NoItem() {
      this._router.navigate(['/']);
   }

   // ---------------------------------------------------------------------------------------------
   // -- SubView 2 - Items
   // ---------------------------------------------------------------------------------------------
   public maengelDetailEdit(data: Mangel) {
      this._mdlgMaengelDetail.openDialog(data.uid);
   }

   public maengelDetailCanceled(): void {
   }

   public maengelDetailSubmit(): void {
   }

   public maengelDetailError(err: ErrorMessage): void {
      this.showErrorMessageView2(err.message);
   }

   // ----------------------------------------------------------------------------------------------
   // -- SubView - Internal Error
   // ----------------------------------------------------------------------------------------------
   public onSubmitSubViewIntErr() {
      this._router.navigate(['/']);
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/maengel/compv/maengelliste-view/maengelliste-view.component.ts